"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyURL = exports.cmxURL = exports.brandingURL = void 0;
exports.getURL = getURL;
exports.solutionURL = exports.rosterURL = exports.recognitionURL = exports.kameURL = exports.idURL = void 0;
function getEnvironment() {
  if (/localhost/.test(window.location.hostname)) {
    return 'qa';
  }
  return window.location.hostname.toLowerCase().split('.').find(function (chunk) {
    return ['ci', 'dev', 'qa', 'pprd'].indexOf(chunk) >= 0;
  });
}
function getURL(url) {
  const env = getEnvironment();
  return url.toLowerCase().replace('(env.)', env ? env + '.' : '');
}
const idURL = exports.idURL = getURL('https://(env.)api.biw.cloud/v1/id');
const cmxURL = exports.cmxURL = getURL('https://(env.)api.biw.cloud/v2/cmx');
const companyURL = exports.companyURL = getURL('https://(env.)api.biw.cloud/v1/company-service');
const solutionURL = exports.solutionURL = getURL('https://(env.)api.biw.cloud/solutionapi/services/v1');
const brandingURL = exports.brandingURL = getURL('https://(env.)api.biw.cloud/v1/branding');
const kameURL = exports.kameURL = getURL('https://(env.)api.biw.cloud/kameapi/graphql');
const rosterURL = exports.rosterURL = getURL('https://(env.)api.biw.cloud/v1/roster');
const recognitionURL = exports.recognitionURL = getURL('https://(env.)api.biw.cloud/v2/recognition');
//# sourceMappingURL=endpoints.js.map